import { Button, Divider, Grid, Paper } from '@material-ui/core';
import React, { memo, useCallback, useEffect, useState } from 'react';
import UploadPhotoRhf from '../../../ReactHookForm/UploadPhotoRhf/UploadPhotoRhf';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import {
    retrackReportLowerQuestions,
    retrackReportLowerQuestionsValidationSchema,
    retrackReportUpperQuestions,
    retrackReportUpperQuestionsValidationSchema,
} from './RetrackReportQuestions';
import RetrackReportTextSection from './RetrackReportTextSection';
import { loopRetrackReportQuestions } from './LoopRetrackReportQuestions';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';
import {
    setHandleValidateRetrackReport,
    setRetrackReportFormData,
    setRetrackReportIsValid,
} from '../../../../store/Retrack/RetrackSlice';
import RetrackReportHeader from './RetrackReportHeader';
import moment from 'moment';
import { useLang } from '../../../../util/lang';
import * as yup from 'yup';
import RadioRhf from '../../../ReactHookForm/RadioRhf/RadioRhf';
import { RadioOptionRhf } from '../../../ReactHookForm/RadioRhf/RadioOptionRhf';
import { filterObjectData } from '../../../../util/function';

const schemaByArchToTreat = (archToTreat) => {
    switch (archToTreat) {
        case 'BOTH': {
            // Explain: link two schema together
            return retrackReportUpperQuestionsValidationSchema.concat(retrackReportLowerQuestionsValidationSchema);
        }
        case 'UPPER': {
            return retrackReportUpperQuestionsValidationSchema;
        }
        case 'LOWER': {
            return retrackReportLowerQuestionsValidationSchema;
        }
    }
};

const RetrackReport = ({ caseId }) => {
    const archToTreatMethods = useForm({
        resolver: yupResolver(
            yup.object().shape({
                archToTreat: yup.string().required('Required'),
            })
        ),
        mode: 'onChange',
        defaultValues: {
            archToTreat: 'BOTH',
        },
    });
    const archToTreatMethodsFormValues = useWatch({ control: archToTreatMethods.control });

    const methods = useForm({
        resolver: yupResolver(schemaByArchToTreat(archToTreatMethodsFormValues.archToTreat)),
        mode: 'onChange',
    });

    const dispatch = useDispatch();
    const get = useLang();

    const upperConfig = retrackReportUpperQuestions();
    const lowerConfig = retrackReportLowerQuestions();

    const onSubmit = (data) => {
        console.log('data: ', data);
        let submitData = { ...data }; //Purpose: avoid readonly object
        // dispatch(setRetrackReportFormData(submitData))
        switch (archToTreatMethodsFormValues.archToTreat) {
            case 'BOTH': {
                submitData['archToTreat'] = 'BOTH';
                console.log('submitBothData: ', submitData);
                dispatch(setRetrackReportFormData(submitData));
                break;
            }
            case 'UPPER': {
                const filteredData = filterObjectData('lower_', submitData);
                filteredData['archToTreat'] = 'UPPER';
                console.log('submitUpperData: ', filteredData);
                dispatch(setRetrackReportFormData(filteredData));
                break;
            }
            case 'LOWER': {
                const filteredData = filterObjectData('upper_', submitData);
                filteredData['archToTreat'] = 'LOWER';
                console.log('submitLowerData: ', filteredData);
                dispatch(setRetrackReportFormData(filteredData));
                break;
            }
        }
    };

    // !Explain: there is a bug in isValid so using retrackReportFormData is null or existed Value to check isValid or not
    useEffect(() => {
        console.log('methods.formState.isValid: ', methods.formState.isValid);
        dispatch(setRetrackReportIsValid(methods.formState.isValid));
    }, [methods.formState.isValid]);

    useEffect(() => {
        dispatch(setHandleValidateRetrackReport(methods.handleSubmit(onSubmit)));
        if (caseId) {
            methods.setValue(retrackReportUpperQuestions().caseIdInput.name, caseId); // Purpose: Value will not be saved in database, just showcase
            methods.setValue(retrackReportUpperQuestions().dateInput.name, moment.utc().format('YYYY-MM-DD')); // PUrpose: Value will not be saved in database, just showcase
        }
    }, [archToTreatMethodsFormValues.archToTreat]);

    return (
        <>
            <FormProvider {...archToTreatMethods}>
                <Grid item xs={12} sm={12} style={{ display: 'flex', paddingBottom: 16 }}>
                    <RadioRhf
                        key={'archToTreat'}
                        question={'Arch to treat'}
                        name={'archToTreat'}
                        defaultValue={'BOTH'}
                        formControlLabelRhf={[
                            { value: 'BOTH', label: 'Both' },
                            { value: 'UPPER', label: 'Upper Only' },
                            { value: 'LOWER', label: 'Lower Only' },
                        ].map((v) => (
                            <RadioOptionRhf key={v.value} value={v.value} label={v.label} disable={false} />
                        ))}
                    />
                </Grid>
            </FormProvider>
            <FormProvider {...methods}>
                <Paper elevation={5}>
                    <Grid container style={{ padding: 32 }} spacing={2}>
                        {
                            // Explain: Use Grid container cos div will affect photo layout arrangment
                            <Grid
                                container
                                spacing={2}
                                style={{
                                    display:
                                        archToTreatMethodsFormValues.archToTreat === 'BOTH' ||
                                        archToTreatMethodsFormValues.archToTreat === 'UPPER'
                                            ? ''
                                            : 'none',
                                    paddingBottom: 32,
                                }}
                            >
                                <RetrackReportHeader />
                                {loopRetrackReportQuestions(upperConfig, 'Upper', false, get)}
                            </Grid>
                        }

                        {
                            <Grid
                                container
                                spacing={2}
                                style={{
                                    display:
                                        archToTreatMethodsFormValues.archToTreat === 'BOTH' ||
                                        archToTreatMethodsFormValues.archToTreat === 'LOWER'
                                            ? ''
                                            : 'none',
                                }}
                            >
                                <RetrackReportHeader />
                                {loopRetrackReportQuestions(lowerConfig, 'Lower', false, get)}
                            </Grid>
                        }

                        {/* Purpose: debug usage */}
                        {/* <Grid item style={{ display: 'flex' }} xs={12} >
                            <Button onClick={methods.handleSubmit(onSubmit)} variant='contained'>Submit</Button>
                        </Grid> */}
                    </Grid>
                </Paper>
            </FormProvider>
        </>
    );
};

export default memo(RetrackReport);
